export const layoutConfig = {
  scrollableAreaSubtrahend: 110,
  scrollableAreaWithoutSecondaryNavigationSubtrahend: 64,
};
